import { render, staticRenderFns } from "./CryptoDeposit.vue?vue&type=template&id=a1573460&"
import script from "./CryptoDeposit.vue?vue&type=script&lang=js&"
export * from "./CryptoDeposit.vue?vue&type=script&lang=js&"
import style0 from "./CryptoDeposit.vue?vue&type=style&index=0&id=a1573460&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports